/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Branches_Table_ActionsInputs */

const en_branches_table_actions = /** @type {(inputs: Branches_Table_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

const pt_br2_branches_table_actions = /** @type {(inputs: Branches_Table_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ações`)
};

/**
* | output |
* | --- |
* | "Actions" |
*
* @param {Branches_Table_ActionsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const branches_table_actions = /** @type {((inputs?: Branches_Table_ActionsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Branches_Table_ActionsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_branches_table_actions(inputs)
	return pt_br2_branches_table_actions(inputs)
});